<script setup lang="ts">
import { onMounted } from 'vue'
import ErrorBoundary from '@/components/ErrorBoundary.vue'
import { useFontAwesome } from '@/composables/useFontAwesome'

// Load FontAwesome for app-wide icon support
const { loadFontAwesome } = useFontAwesome()

// Handle errors from error boundary
const handleError = (error: Error, errorInfo: any) => {
  console.error('App-level error:', error, errorInfo)
}

// Load FontAwesome when app starts
onMounted(async () => {
  await loadFontAwesome()
})

</script>

<template>
  <!-- Wrap the entire app in an error boundary -->
  <ErrorBoundary @error="handleError">
    <!-- router-view is where Vue Router will render the current page component -->
    <router-view />
    
  </ErrorBoundary>
</template>
